export default "/images/chat-icon.svg?f032be1de526b90c22006c9ce07d23d8";